module.exports = __webpack_public_path__ + "static/media/oil-can.dd8f7f67.svg";